angular.module('unergie.main')
.controller('userContractInfoCtrl', ($rootScope, $scope, $stateParams, BoFeaturesService, StoreService, UserInfoContractReducer,
    RootAccountActions, AccountService, MetaWatcher) => {
    const store = StoreService.createStore(UserInfoContractReducer.reducer)
    $scope.onDispatch = store.onDispatch
    $scope.isFeatureOn = BoFeaturesService.isFeatureOn
    $scope.state = null
    $scope.account = null
    $scope.contractDrafts = []
    const feats = BoFeaturesService.getModuleFeatures('accountinfo')

    $scope.isAIFeatureOn = (feature) => feats[feature]

    // Isolate dispatch method here and replace it later
    $scope.refreshAccount = () => $scope.onDispatch(RootAccountActions.refreshAccount())

    $scope.updateContract = (contract) => $scope.onDispatch(RootAccountActions.updateContract($scope.account, contract))

    $scope.updateContractDrafts = () => $scope.onDispatch(RootAccountActions.fetchContractDraft())

    $scope.refreshTab = () => $scope.onDispatch(RootAccountActions.refreshTab())

    $scope.refreshTabDone = () => $scope.onDispatch(RootAccountActions.refreshTabDone())

    const activate = function () {
        store.connect((state) => {
            $scope.state = state
            $scope.account = state.account
            $scope.contractDrafts = state.contractDrafts
        })
        const { search, customerId, contractId } = $stateParams
        let accountId
        $scope.onDispatch(RootAccountActions.initAccount($scope, search, accountId, customerId, contractId))

        AccountService.watch('userContractInfoCtrl', (account, id_contract) => $scope.onDispatch(RootAccountActions.onAccountFetched(null, account, id_contract, $scope)))

        MetaWatcher.watch('CONTRACT_DRAFT_CHANGED', 'userContractInfo', $scope, $scope.updateContractDrafts)
    }

    activate()
})
